class CookieConsent {
    constructor() {
        this.consentElement = document.getElementById('cookie-consent');
        this.allButton = null;
        this.necessaryButton = null;
        this.manager = null;

        this.init();
    }

    init() {
        if (!this.consentElement) {
            return;
        }

        if (!window.CookieConsentManager) {
            return;
        }

        this.manager = new window.CookieConsentManager({
            storageKey: 'cookie_consent_status',
            policyVersion: this.consentElement.dataset.consentVersion || '1.0.0',
        });

        this.allButton = this.consentElement.querySelector('[data-action="all"]');
        this.necessaryButton = this.consentElement.querySelector('[data-action="necessary"]');

        const consent = this.manager.getConsent();

        if (!consent) {
            this.show();
        } else {
            this.hide();
        }

        this.manager.emitReady();
        this.bindEvents();
    }

    show() {
        if (this.consentElement) {
            this.consentElement.style.display = 'flex';
            // Небольшая задержка для плавного появления
            setTimeout(() => {
                this.consentElement.classList.add('cookie-consent--visible');
            }, 10);
        }
    }

    hide() {
        if (this.consentElement) {
            this.consentElement.classList.remove('cookie-consent--visible');
            setTimeout(() => {
                this.consentElement.style.display = 'none';
            }, 300);
        }
    }

    handleAll() {
        this.manager.acceptAll('banner');
        this.hide();
    }

    handleNecessary() {
        this.manager.acceptNecessary('banner');
        this.hide();
    }

    bindEvents() {
        if (this.allButton) {
            this.allButton.addEventListener('click', () => this.handleAll());
        }

        if (this.necessaryButton) {
            this.necessaryButton.addEventListener('click', () => this.handleNecessary());
        }
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        new CookieConsent();
    });
} else {
    new CookieConsent();
}
